// extracted by mini-css-extract-plugin
export default {"root":"NotFoundBlock_root__6SXV8","descr":"NotFoundBlock_descr__xMINq"};